<template>
  <div id="overview-patent-tab">
    <div>
      <v-container class="content-wrapper" fluid id="overview-patent-tab">
        <v-row justify="center" align="center">
          <v-col cols="12" lg="10">
            <v-card
              class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
              elevation="3"
              style="border-radius: 24px;"
            >
              <!-- Back to the Patent -->
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="auto">
                    <v-btn
                      depressed
                      rounded
                      small
                      color="blue"
                      class="white--text font-weight-bold"
                      @click="goBack"
                    >
                      <v-icon color="black" small class="mr-2">
                        mdi-arrow-left
                      </v-icon>
                      Back
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <!-- Logo Patent -->
              <v-card-text>
                <v-row align="center" justify="start">
                  <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                    <v-img
                      :src="patent.logo"
                      class="resource-image"
                      lazy-src="@/assets/img/blur.jpg"
                      contain
                      style="max-width: 200px; border-radius: 19.875px;"
                    ></v-img>
                    <!-- <v-card-text class="mt-5">
                      <v-icon>mdi-eye</v-icon>
                      {{ patent.views }} registered views
                    </v-card-text>
                    <v-card-text class="pt-0">
                      <v-icon>mdi-eye</v-icon>
                      {{ patent.viewsNonRegistered }} non registered views
                    </v-card-text> -->
                  </v-col>
                </v-row>
              </v-card-text>

              <!-- Main body -->
              <v-card-text>
                <v-row align="center" no-gutters>
                  <v-col cols="auto">
                    <h2 class="black--text">
                      {{ patent.title }}
                    </h2>
                  </v-col>
                  <v-col cols="auto" class="mx-4">
                    <v-btn @click.stop="modalLogIn = true" elevation="2" icon raised medium>
                      <v-icon>mdi-heart-outline</v-icon>
                    </v-btn>
                  </v-col>
                  <!-- <v-col>
                    <v-btn @click.stop="modalLogIn = true" elevation="2" icon raised medium>
                      <v-icon>mdi-email-outline</v-icon>
                    </v-btn>
                  </v-col> -->
                </v-row>
              </v-card-text>
              <v-card-text class="pt-0">
                <v-chip flat label medium color="blue" class="white--text font-weight-bold">
                  Patents
                </v-chip>
              </v-card-text>
              <v-card-text v-if="patent.abstract">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Abstract
                    </h3>
                    <div v-html="patent.abstract"></div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="patent.patentStatus && patent.patentStatus.name">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Patent Status
                    </h3>
                    <p>
                      {{ patent.patentStatus.name }}
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="patent.provider && patent.provider.id && patent.provider.name">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Provider:
                    </h3>
                    <template v-if="patent && patent.provider && patent.provider.id">
                      <router-link
                        :to="{ name: 'PublicOverviewProvider', params: { id: patent.provider.id } }"
                        style="text-decoration: underline; color: inherit;"
                      >
                        {{ patent.provider.name }}
                      </router-link>
                    </template>
                    <template v-else>
                      <span>No provider available</span>
                    </template>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text
                v-if="
                  patent.provider.hostingInstitution &&
                    patent.provider.hostingInstitution.id &&
                    patent.provider.hostingInstitution.name
                "
              >
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Hosting Institution Entity:
                    </h3>
                    <router-link
                      :to="{
                        name: 'PublicOverviewHostingInstitution',
                        params: { id: patent.provider.hostingInstitution.id },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ patent.provider.hostingInstitution.name }}
                    </router-link>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="patent.tags.length">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Tags
                    </h3>
                  </v-col>
                </v-row>
                <v-row v-if="patent.tags.length > 0">
                  <v-chip
                    :color="color(index)"
                    v-for="(tag, index) in patent.tags"
                    :key="index"
                    class="ma-2"
                  >
                    {{ tag }}
                  </v-chip>
                </v-row>
              </v-card-text>
              <v-card-text class="mt-5">
                <v-row>
                  <v-col cols="2">
                    <v-btn
                      @click.stop="modalLogIn = true"
                      block
                      depressed
                      rounded
                      large
                      color="primary200"
                      class="white--text font-weight-bold"
                    >
                      <v-icon color="white" class="mr-2">mdi-cart-outline</v-icon>
                      License Request
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>

              <!-- Overview Patent Tabs -->
              <v-card-text>
                <v-tabs v-model="tab" show-arrows active-class="primary200--text">
                  <v-tabs-slider color="primary200"></v-tabs-slider>
                  <v-tab v-if="basicInfoTab">{{ $t('basic') }}</v-tab>
                  <v-tab v-if="detailedTab">{{ $t('detailed') }}</v-tab>
                  <v-tab v-if="classificationTab">{{ $t('classification') }}</v-tab>
                  <!-- <v-tab v-if="contactTab">{{ $t('contact') }}</v-tab> -->
                  <v-tab v-if="managementTab">{{ $t('management') }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <!-- Basic Info -->
                  <v-tab-item
                    v-if="basicInfoTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="0"
                  >
                    <v-row class="mt-10">
                      <v-col v-if="patent.basicInfo.patentNumber" cols="12" md="2" sm="12">
                        <label>Patent Number</label>
                        <p>
                          {{ patent.basicInfo.patentNumber }}
                        </p>
                      </v-col>
                      <v-col v-if="patent.basicInfo.applicationNumber" cols="12" md="2" sm="12">
                        <label>Application Number</label>
                        <p>
                          {{ patent.basicInfo.applicationNumber }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0 pt-0">
                      <v-col
                        v-if="patent.basicInfo.owners && patent.basicInfo.owners.length"
                        cols="12"
                        md="2"
                        sm="12"
                      >
                        <label>Assignee or Owner</label>
                        <p>
                          <span v-for="(owner, index) in patent.basicInfo.owners" :key="index">
                            {{ owner }}
                            <span v-if="index < patent.basicInfo.owners.length - 1">, </span>
                          </span>
                        </p>
                      </v-col>
                      <v-col
                        v-if="patent.basicInfo.owners && patent.basicInfo.owners.length"
                        cols="12"
                        md="2"
                        sm="12"
                      >
                        <label>Inventors</label>
                        <p>
                          <span
                            v-for="(inventor, index) in patent.basicInfo.inventors"
                            :key="index"
                          >
                            {{ inventor }}
                            <span v-if="index < patent.basicInfo.inventors.length - 1">, </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0 pt-0">
                      <v-col
                        v-if="
                          patent.basicInfo.patentOffices && patent.basicInfo.patentOffices.length
                        "
                        cols="12"
                        md="2"
                        sm="12"
                      >
                        <label>Patent Offices</label>
                        <p>
                          <span
                            v-for="(patentOffice, index) in patent.basicInfo.patentOffices"
                            :key="index"
                          >
                            {{ patentOffice }}
                            <span v-if="index < patent.basicInfo.patentOffices.length - 1">, </span>
                          </span>
                        </p>
                      </v-col>
                      <v-col v-if="patent.basicInfo.fillingDate" cols="12" md="2" sm="12">
                        <label>Filling Date</label>
                        <p>
                          {{ formatDate(patent.basicInfo.fillingDate) }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="patent.basicInfo.issueDate" class="mt-0 pt-0">
                      <v-col cols="12" md="2" sm="12">
                        <label>Issue Date</label>
                        <p>
                          {{ formatDate(patent.basicInfo.issueDate) }}
                        </p>
                      </v-col>
                      <v-col v-if="patent.basicInfo.expirationDate" cols="12" md="2" sm="12">
                        <label>Expiration Date</label>
                        <p>
                          {{ formatDate(patent.basicInfo.expirationDate) }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Detailed Info -->
                  <v-tab-item
                    v-if="detailedTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="1"
                  >
                    <v-row v-if="patent.detailedInfo.description" class="mt-10">
                      <v-col cols="6">
                        <label>Description</label>
                        <div v-html="patent.detailedInfo.description"></div>
                      </v-col>
                    </v-row>
                    <v-row v-if="patent.detailedInfo.link" class="mt-0 pt-0">
                      <v-col cols="12" md="2" sm="12">
                        <label>Link</label>
                        <p>
                          <a
                            :href="patent.detailedInfo.link"
                            target="_blank"
                            rel="noopener noreferrer"
                            style="text-decoration: underline; color: inherit;"
                          >
                            {{ patent.detailedInfo.link }}
                          </a>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0 pt-0">
                      <v-col
                        v-if="patent.detailedInfo.useCases && patent.detailedInfo.useCases.length"
                        cols="12"
                        md="2"
                        sm="12"
                      >
                        <label>Use Cases</label>
                        <p>
                          <span
                            v-for="(useCase, index) in patent.detailedInfo.useCases"
                            :key="index"
                          >
                            {{ useCase }}
                            <span v-if="index < patent.detailedInfo.useCases.length - 1">, </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="patent.detailedInfo.factSheet" class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label>Fact Sheet</label>
                        <p>
                          <v-btn
                            v-if="patent.detailedInfo.factSheet"
                            :disabled="!$store.getters.roles"
                            @click="downloadFactSheet(patent.detailedInfo.factSheet)"
                            icon
                            raised
                            small
                          >
                            <v-icon>mdi-file-pdf-box</v-icon>
                          </v-btn>
                          {{ patent.detailedInfo.factSheet }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Classification Info -->
                  <v-tab-item
                    v-if="classificationTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="2"
                  >
                    <v-row class="mt-10">
                      <v-col
                        v-if="
                          patent.classificationInfo.patentTechnologies &&
                            patent.classificationInfo.patentTechnologies.length
                        "
                        cols="12"
                        md="2"
                        sm="12"
                      >
                        <label>Patent Technologies</label>
                        <p>
                          <span
                            v-for="(patentTechnology, index) in patent.classificationInfo
                              .patentTechnologies"
                            :key="index"
                          >
                            {{ patentTechnology.name }}
                            <span
                              v-if="index < patent.classificationInfo.patentTechnologies.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Contact Info -->
                  <!-- <v-tab-item
                    v-if="contactTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="3"
                  >
                    <v-row v-if="patent.contactInfo.email">
                      <v-col cols="12" lg="5" xl="4" md="6" sm="12">
                        <v-card class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6 custom-card">
                          <v-row align="center">
                            <v-col cols="12" lg="3" xl="3" md="12" sm="12">
                              <v-card-text style="filter: blur(3px);">
                                <v-avatar
                                  :size="80"
                                  class="white--text text-bold"
                                  :color="'primary'"
                                >
                                  {{ letters }}
                                </v-avatar>
                              </v-card-text>
                            </v-col>
                            <v-col cols="12" lg="9" xl="9" md="12" sm="12">
                              <v-card-title
                                class="black--text text-bold"
                                style="filter: blur(4px);"
                              >
                                {{ patent.contactInfo.lastname }}
                                {{ patent.contactInfo.firstname }}
                              </v-card-title>
                              <v-card-text
                                class="mt-0 pt-0 primary200--text text-bold"
                                style="filter: blur(3px);"
                              >
                                {{ patent.contactInfo.email }}
                              </v-card-text>
                              <v-card-text
                                class="mt-0 pt-0 primary200--text text-bold"
                                style="filter: blur(3px);"
                              >
                                {{ patent.contactInfo.phone }}
                              </v-card-text>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-tab-item> -->

                  <!-- Management Info -->
                  <v-tab-item
                    v-if="managementTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="4"
                  >
                    <v-row v-if="patent.managementInfo.documentation" class="mt-10">
                      <v-col cols="12" md="6" sm="12">
                        <label>Documentation</label>
                        <p>
                          <a
                            :href="patent.managementInfo.documentation"
                            target="_blank"
                            rel="noopener noreferrer"
                            style="text-decoration: underline; color: inherit;"
                          >
                            {{ patent.managementInfo.documentation }}
                          </a>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="patent.managementInfo.termsOfLicense" class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label>Terms of License</label>
                        <p>
                          <a
                            :href="patent.managementInfo.termsOfLicense"
                            target="_blank"
                            rel="noopener noreferrer"
                            style="text-decoration: underline; color: inherit;"
                          >
                            {{ patent.managementInfo.termsOfLicense }}
                          </a>
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>

            <!-- Other Resources -->
            <v-card
              v-if="paginatedResources.length"
              class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
              elevation="3"
              style="border-radius: 24px;"
            >
              <v-card-title class="black--text mt-0 pt-0">
                <v-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  class="d-flex align-center justify-center justify-md-start justify-xl-start justify-lg-start mt-0 pt-0"
                >
                  Other Resources
                </v-col>
                <v-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  class="d-flex justify-center justify-md-end justify-xl-end justify-lg-end align-center mt-0 pt-0"
                >
                  <v-btn :disabled="currentPage === 1" @click="currentPage--" small plain>
                    <v-icon color="black" small class="mr-2">
                      mdi-arrow-left
                    </v-icon>
                  </v-btn>
                  <span> {{ currentPage }} / {{ totalPages }}</span>
                  <v-btn :disabled="currentPage === totalPages" @click="currentPage++" small plain>
                    <v-icon color="black" small class="mr-2">
                      mdi-arrow-right
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    xl="3"
                    lg="3"
                    md="3"
                    sm="6"
                    class="pa-3"
                    v-for="(resource, index) in paginatedResources"
                    :key="'resource-' + index"
                  >
                    <v-hover v-slot="{ hover }">
                      <v-card
                        class="d-flex justify-center align-center"
                        elevation="3"
                        style="border-radius: 24px; height: 100%;"
                        :class="{ 'on-hover': hover }"
                        @click="redirect(resource)"
                      >
                        <v-card-text>
                          <v-row align="center">
                            <v-col cols="12" xl="6" lg="12" md="12" sm="12" align="center">
                              <v-img
                                v-if="resource.logo"
                                height="120px"
                                max-width="80%"
                                contain
                                v-bind:src="resource.logo"
                                :style="{
                                  borderTopLeftRadius: '24px',
                                  borderTopRightRadius: '24px',
                                }"
                              ></v-img>
                              <v-img
                                v-else
                                height="120px"
                                max-width="80%"
                                contain
                                :src="require('@/assets/img/blur.jpg')"
                              />
                            </v-col>
                            <v-col cols="12" xl="6" lg="12" md="12" sm="12" align="center">
                              <div class="mt-0 pt-0">
                                <span class="text-bold black--text">
                                  {{ resource.name }}
                                </span>
                              </div>
                              <div class="mt-0 pt-0">
                                <span class="text-bold">
                                  {{ resource.orderable ? 'Orderable' : 'Non Orderable' }}
                                </span>
                              </div>
                              <div>
                                <v-chip
                                  depressed
                                  rounded
                                  small
                                  color="blue"
                                  class="white--text font-weight-bold"
                                >
                                  {{ resource.label }}
                                </v-chip>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-hover>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Non registered dialog -->
        <v-dialog v-model="modalLogIn" max-width="1000px">
          <v-card
            class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
          >
            <v-card-title class="px-0 py-0">
              <v-row class="mx-0 px-2" align="center">
                <v-col cols="11" class="text-center d-flex justify-center align-center">
                  This action requires authentication
                </v-col>
                <v-col cols="1" class="pl-0">
                  <v-btn fab small text @click="modalLogIn = false">
                    <v-icon color="neutral500">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="mt-1 mb-6 my-sm-6 my-lg-6 my-xl-6 my-md-6"></v-divider>
            <v-card-text class="pa-0 text-center">
              Only authenticated users are allowed to perform this action. Please
              <router-link :to="{ name: 'OverviewPatent', params: { id: $route.params.id } }"
                ><span class="font-weight-bold">Log In</span></router-link
              >
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
  </div>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import util from '@/mixins/util.js';

export default {
  name: 'PublicOverviewPatent',
  mixins: [util],
  data() {
    return {
      patent: {
        logo: '',
        views: null,
        viewsNonRegistered: null,
        title: '',
        abstract: '',
        patentStatus: {
          id: null,
          name: '',
        },
        provider: {
          name: '',
          hostingInstitution: {
            id: null,
            name: '',
          },
          id: '',
        },
        tags: [],
        basicInfo: {
          patentNumber: '',
          applicationNumber: '',
          owners: [],
          inventors: [],
          patentOffices: [],
          fillingDate: null,
          issueDate: null,
          expirationDate: null,
        },
        detailedInfo: {
          description: '',
          factSheet: null,
          useCases: [],
          link: '',
        },
        classificationInfo: {
          patentTechnologies: [],
        },
        contactInfo: {
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
          verified: false,
        },
        managementInfo: {
          documentation: '',
          termsOfLicense: '',
        },
      },
      isFavorite: false,
      tab: null,
      letters: '',
      favoriteQuery: '',
      marketplacePatentsViewAll: '',
      isVerified: {
        verified: false,
      },
      modalLogIn: false,
      patentSearchMarketplaceQuery: '',
      resources: [],
      currentPage: 1,
      itemsPerPage: 8,
    };
  },
  mounted() {
    this.getPatent();
    this.favoriteQuery = this.$route.query.favoritePatent;
    this.patentSearchMarketplaceQuery = this.$route.query.patentSearchMarketplace;

    this.marketplacePatentsViewAll = this.$route.query.marketplacePatentsViewAll;
  },
  beforeUpdate() {
    const { firstname, lastname } = this.patent.contactInfo;
    this.letters = '';

    if (lastname && firstname) {
      this.letters = lastname.charAt(0) + firstname.charAt(0);
    }
  },
  computed: {
    basicInfoTab() {
      if (
        this.patent.basicInfo.patentNumber ||
        this.patent.basicInfo.applicationNumber ||
        this.patent.basicInfo.owners.length ||
        this.patent.basicInfo.inventors.length ||
        this.patent.basicInfo.patentOffices.length ||
        this.patent.basicInfo.fillingDate ||
        this.patent.basicInfo.issueDate ||
        this.patent.basicInfo.expirationDate
      ) {
        return true;
      } else {
        return false;
      }
    },
    detailedTab() {
      if (
        this.patent.detailedInfo.description ||
        this.patent.detailedInfo.factSheet ||
        this.patent.detailedInfo.useCases.length ||
        this.patent.detailedInfo.link
      ) {
        return true;
      } else {
        return false;
      }
    },
    classificationTab() {
      if (this.patent.classificationInfo.patentTechnologies.length) {
        return true;
      } else {
        return false;
      }
    },
    contactTab() {
      if (this.patent.contactInfo.email) {
        return true;
      } else {
        return false;
      }
    },
    managementTab() {
      if (this.patent.managementInfo.documentation || this.patent.managementInfo.termsOfLicense) {
        return true;
      } else {
        return false;
      }
    },
    paginatedResources() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.resources.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.resources.length / this.itemsPerPage);
    },
  },
  methods: {
    getPatent() {
      EventBus.$emit('waiting', true);
      const id = this.$route.params.id;

      this.axios
        .get(`/api/v1/patent/${id}`)
        .then(response => {
          console.log('Get Patent', response.data);

          this.isFavorite = response.data.isFavorite;
          this.patent.logo = response.data.logo;
          this.patent.views = response.data.views;
          this.patent.viewsNonRegistered = response.data.viewsNonRegistered;
          this.patent.title = response.data.title;
          this.patent.abstract = response.data.patentAbstract;
          this.patent.patentStatus = {
            id: response.data.patentStatus.id,
            name: response.data.patentStatus.name,
          };
          this.patent.provider = {
            name: response.data.organisation.name,
            hostingInstitution: {
              id: response.data.organisation.hostingInstitution.id,
              name: response.data.organisation.hostingInstitution.name,
            },
            id: response.data.organisation.id,
          };
          this.patent.tags = response.data.tags;

          this.patent.basicInfo = {
            patentNumber: response.data.patentNumber,
            applicationNumber: response.data.applicationNumber,
            owners: response.data.owners,
            inventors: response.data.inventors,
            patentOffices: response.data.patentOffices,
            fillingDate: response.data.fillingDate,
            issueDate: response.data.issueDate,
            expirationDate: response.data.expirationDate,
          };

          this.patent.detailedInfo = {
            description: response.data.description,
            link: response.data.link,
            useCases: response.data.useCases,
            factSheet: response.data.factsheet,
          };

          this.patent.classificationInfo = {
            patentTechnologies: response.data.patentTechnologies,
          };

          const verifiedContact = response.data.publicContacts?.find(
            contact => contact.verified === true,
          );

          this.isVerified.verified = verifiedContact ? verifiedContact.verified : false;

          this.patent.contactInfo = {
            firstname: verifiedContact?.firstname,
            lastname: verifiedContact?.lastname,
            email: verifiedContact?.email,
            phone: verifiedContact?.phone,
            verified: verifiedContact ? verifiedContact.verified : false,
          };

          // this.patent.contactInfo = {
          //   firstname:
          //     response.data.publicContacts && response.data.publicContacts.length > 0
          //       ? response.data.publicContacts[0].firstname
          //       : '-',
          //   lastname:
          //     response.data.publicContacts && response.data.publicContacts.length > 0
          //       ? response.data.publicContacts[0].lastname
          //       : '-',
          //   email:
          //     response.data.publicContacts && response.data.publicContacts.length > 0
          //       ? response.data.publicContacts[0].email
          //       : '-',
          //   phone:
          //     response.data.publicContacts && response.data.publicContacts.length > 0
          //       ? response.data.publicContacts[0].phone
          //       : '-',
          //   verified:
          //     response.data.publicContacts &&
          //     response.data.publicContacts.length > 0 &&
          //     response.data.publicContacts[0].verified,
          // };

          this.patent.managementInfo = {
            documentation: response.data.documentation,
            termsOfLicense: response.data.termsOfLicense,
          };
          this.getOtherResources(this.patent);
        })
        .catch(error => {
          console.error('Error fetching patent data:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    getOtherResources(patent) {
      EventBus.$emit('waiting', true);

      const providerId = patent.provider.id;
      const excludedId = this.$route.params.id;

      this.axios
        .get(`api/v1/equipment/other-resources`, {
          params: {
            providerId,
          },
        })
        .then(response => {
          console.log('Response data from Other Resources:', response.data);

          this.resources = response.data.filter(
            resource => resource.id !== parseInt(excludedId, 10),
          );

          this.currentPage = 1;
        })
        .catch(error => {
          console.error('Error fetching other resources:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    addFavorite() {
      const id = this.$route.params.id;

      EventBus.$emit('waiting', true);

      this.axios
        .post(`/api/v1/favorites-patents/${id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite added successfully',
          });
          this.isFavorite = true;
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    removeFavorite() {
      const id = this.$route.params.id;

      EventBus.$emit('waiting', true);

      this.axios
        .delete(`/api/v1/favorites-patents/${id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite removed successfully',
          });
          this.isFavorite = false;
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    downloadFactSheet(file) {
      const id = this.$route.params.id;
      const filePath = `api/v1/patent/${id}/file/${file}?field=factSheet`;

      this.axios
        .get(filePath, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], {
            type: response.headers['content-type'],
          });

          const fileURL = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = fileURL;
          a.download = file;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          URL.revokeObjectURL(fileURL);
        })
        .catch(error => {
          console.error('Error fetching file:', error);
        });
    },
    goBack() {
      if (this.marketplacePatentsViewAll && this.$route.query.fromTable) {
        const marketplacePatentsViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Patents';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/patents';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplacePatentsViewAll, ...fromTable },
        });
      } else if (this.marketplacePatentsViewAll && this.$route.query.filters) {
        const marketplacePatentsViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Patents';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/patents';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplacePatentsViewAll, ...filters },
        });
      } else if (this.patentSearchMarketplaceQuery && this.$route.query.filters) {
        localStorage.setItem('tabIndex', 2);
        const filters = this.$route.query;
        this.$router.push({
          name: 'PublicSearchMarketplace',
          query: filters,
        });
      } else {
        this.$router.go(-1);
      }
    },
    redirect(resource) {
      const id = resource.id;
      const label = resource.label;

      if (id && label === 'Service' && !this.$store.getters.roles) {
        this.$router.push({ name: 'PublicOverviewService', params: { id: id } });
      }

      if (id && label === 'Equipment' && !this.$store.getters.roles) {
        this.$router.push({ name: 'PublicOverviewEquipment', params: { id: id } });
      }

      if (id && label === 'Patent' && !this.$store.getters.roles) {
        this.$router.push({ name: 'PublicOverviewPatent', params: { id: id } });
        this.$nextTick(() => {
          this.getPatent();
        });
      }
    },
  },
};
</script>

<style>
#overview-patent-tab .v-toolbar {
  background: rgba(250, 250, 250, 1) !important;
  border-bottom: 2px solid #f4f2f9 !important;
}

#overview-patent-tab .custom-app-bar {
  background-color: rgba(0, 0, 0, 0) !important;
  border-bottom: none !important;
}
</style>
